/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	ResearchPartnersForProfessorOrCompanyDTO,
	ResearchPartnersForProfessorOrCompanyDTOFromJSON,
	ResearchPartnersForProfessorOrCompanyDTOFromJSONTyped,
	ResearchPartnersForProfessorOrCompanyDTOToJSON,
} from "./ResearchPartnersForProfessorOrCompanyDTO";

/**
 *
 * @export
 * @interface ResearchPartnersForProfessorOrCompanyDTOPagedResponse
 */
export interface ResearchPartnersForProfessorOrCompanyDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof ResearchPartnersForProfessorOrCompanyDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof ResearchPartnersForProfessorOrCompanyDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof ResearchPartnersForProfessorOrCompanyDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<ResearchPartnersForProfessorOrCompanyDTO>}
	 * @memberof ResearchPartnersForProfessorOrCompanyDTOPagedResponse
	 */
	data?: Array<ResearchPartnersForProfessorOrCompanyDTO> | null;
}

export function ResearchPartnersForProfessorOrCompanyDTOPagedResponseFromJSON(
	json: any
): ResearchPartnersForProfessorOrCompanyDTOPagedResponse {
	return ResearchPartnersForProfessorOrCompanyDTOPagedResponseFromJSONTyped(
		json,
		false
	);
}

export function ResearchPartnersForProfessorOrCompanyDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ResearchPartnersForProfessorOrCompanyDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(
					ResearchPartnersForProfessorOrCompanyDTOFromJSON
			  ),
	};
}

export function ResearchPartnersForProfessorOrCompanyDTOPagedResponseToJSON(
	value?: ResearchPartnersForProfessorOrCompanyDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(
						ResearchPartnersForProfessorOrCompanyDTOToJSON
				  ),
	};
}
